module.exports = __webpack_public_path__ + "img/omen.f58d18ce.png";